import { render, staticRenderFns } from "./MainCheckboxOffers.vue?vue&type=template&id=ee2a1abc&scoped=true"
import script from "./MainCheckboxOffers.vue?vue&type=script&lang=js"
export * from "./MainCheckboxOffers.vue?vue&type=script&lang=js"
import style0 from "./MainCheckboxOffers.vue?vue&type=style&index=0&id=ee2a1abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2a1abc",
  null
  
)

export default component.exports